module.exports = __webpack_public_path__ + "static/img/8.f6c847a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/8.png
// module id = iTVz
// module chunks = 1